module.exports = __webpack_public_path__ + "static/specialists-slideshow-01@2x-321f5f4855ae73fdbf53b6c723f7e98a.jpg";